import React, { useEffect } from 'react';
import { useToast } from '@chakra-ui/react';
import toastService from '../utils/toastService';

const ToastProvider = ({ children }) => {
  const toast = useToast();

  useEffect(() => {
    // Initialize the toast service with the useToast function
    toastService.setToastFunction(toast);
    
    // Cleanup function
    return () => {
      toastService.setToastFunction(null);
    };
  }, [toast]);

  return <>{children}</>;
};

export default ToastProvider;